// PreventiApp · Sprint 4 · Anonimización cliente con MediaPipe Face Detector.
// Carga MediaPipe Tasks Vision desde CDN oficial (sin dependencia npm).
// TODO privacidad: NO se envían imágenes fuera del navegador. Todo el procesamiento
// ocurre en memoria; los ROI de rostros son coordenadas efímeras, nunca embeddings.

const CDN = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
const MODEL_URL = 'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite';

let _detectorPromise = null;

async function loadModule() {
  const mod = await import(/* webpackIgnore: true */ `${CDN}/vision_bundle.mjs`);
  return mod;
}

async function getDetector() {
  if (_detectorPromise) return _detectorPromise;
  _detectorPromise = (async () => {
    const { FaceDetector, FilesetResolver } = await loadModule();
    const fileset = await FilesetResolver.forVisionTasks(`${CDN}/wasm`);
    const detector = await FaceDetector.createFromOptions(fileset, {
      baseOptions: { modelAssetPath: MODEL_URL, delegate: 'CPU' },
      runningMode: 'IMAGE',
      minDetectionConfidence: 0.5,
    });
    return detector;
  })().catch((e) => { _detectorPromise = null; throw e; });
  return _detectorPromise;
}

// Detecta rostros en un HTMLImageElement o HTMLCanvasElement.
// Devuelve [{x, y, w, h}] en coordenadas de píxel.
export async function detectFaces(imageEl) {
  const det = await getDetector();
  const res = det.detect(imageEl);
  const width = imageEl.naturalWidth || imageEl.width;
  const height = imageEl.naturalHeight || imageEl.height;
  return (res?.detections || []).map((d) => {
    const b = d.boundingBox;
    return {
      x: Math.max(0, Math.floor(b.originX)),
      y: Math.max(0, Math.floor(b.originY)),
      w: Math.min(width, Math.ceil(b.width)),
      h: Math.min(height, Math.ceil(b.height)),
    };
  });
}

// Pixela irreversiblemente una región del canvas usando redimensionamiento a MOSAIC × MOSAIC.
// El pintado usa imageSmoothingEnabled=false para conservar bloques nítidos.
export function pixelateRegion(ctx, x, y, w, h, mosaic = 8) {
  // Expandimos 10% para asegurar cobertura del rostro completo
  const padX = Math.round(w * 0.10);
  const padY = Math.round(h * 0.10);
  const cw = ctx.canvas.width;
  const ch = ctx.canvas.height;
  const xs = Math.max(0, x - padX);
  const ys = Math.max(0, y - padY);
  const xe = Math.min(cw, x + w + padX);
  const ye = Math.min(ch, y + h + padY);
  const rw = xe - xs;
  const rh = ye - ys;
  if (rw <= 0 || rh <= 0) return;
  // Extraer ROI a canvas auxiliar pequeño → escalar de vuelta con nearest
  const tmp = document.createElement('canvas');
  tmp.width = mosaic;
  tmp.height = mosaic;
  const tctx = tmp.getContext('2d');
  tctx.imageSmoothingEnabled = false;
  tctx.drawImage(ctx.canvas, xs, ys, rw, rh, 0, 0, mosaic, mosaic);
  const prev = ctx.imageSmoothingEnabled;
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(tmp, 0, 0, mosaic, mosaic, xs, ys, rw, rh);
  ctx.imageSmoothingEnabled = prev;
}

// Descarga el modelo/wasm al montar la primera vez para pre-calentar.
export function warmup() {
  getDetector().catch(() => { /* silencioso; se reintenta al usar */ });
}
